/**
 * BalanceIndicator — Saldo com cor dinâmica baseada no valor
 */
import { h } from 'preact';
import { T } from '../../styles/tokens';

export interface BalanceIndicatorProps {
  value: number | null;
  size?: 'sm' | 'md';
}

export function BalanceIndicator({ value, size = 'md' }: BalanceIndicatorProps) {
  const fontSize = size === 'sm' ? 13 : 16;
  const color = value === null ? T.textMuted
    : value > 5 ? T.success
    : value > 1 ? T.warning
    : T.danger;

  return (
    <span style={{ fontSize, fontWeight: 700, color }}>
      {value === null ? '—' : `$${value.toFixed(2)}`}
    </span>
  );
}
